import { useEffect, useState } from "react";

const readVisible = () => typeof document === "undefined" || document.visibilityState !== "hidden";

/**
 * Sekme görünür mü? Arka plandaki sekmede periyodik yenileme (polling)
 * durdurulsun diye kullanılır.
 */
export default function usePageVisible() {
  const [visible, setVisible] = useState(readVisible);
  useEffect(() => {
    const onChange = () => setVisible(readVisible());
    document.addEventListener("visibilitychange", onChange);
    return () => document.removeEventListener("visibilitychange", onChange);
  }, []);
  return visible;
}
